import styles from "./features.module.css";
import { BASE_ASSETS_URL } from "../../constants/constants";
import Link from "next/link";
import Cards from "../../components/FeaturesCards";
import Background from "../../components/FeaturesBackground";
import Head from "next/head";

const Features = () => {
  const features = [
    {
      featuresContainerStyles: "flex-col-reverse md:flex-row mt-0",
      cardImgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/1.png",
      cardImgAlt: "Features",
      cardImgLoading: "eager",
      cardTagText2: "FEATURES",
      cardHeadingText1: "Discover how BoloForms Approvals works.",
      cardDescText1:
        "Learn how to automate your approvals and transform your business.",
      cardBtnText2: "Try For Free!",
      cardClassName: `${styles.section_1} mt-[50px!important]`,
      bgImgSrc: `${BASE_ASSETS_URL}/features/bg_1.svg`,
      bgContainerStyles: { bottom: "-300px" },
      bgClassNameContainer:
        "bottom-[-50px!important] sm:bottom-[-150px!important] lg:bottom-[-200px!important] xl:bottom-[-250px!important] xxl:bottom-[-350px!important]",
      bgImgStyles: { transform: "scaleX(-1)" },
    },
    {
      featuresContainerStyles: "mt-10 sm:mt-40",
      cardImgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/2.png",
      cardImgAlt: "User-Friendly Approval Builder",
      cardTagText1: "Easy-to-Use Builder",
      cardHeadingText1: "User-Friendly Approval Builder",
      cardDescText1:
        "With BoloForms' intuitive & simple interface, you can easily enhance your approval workflow, add new approvers, send PDFs & set up tailored emails, and much more. In just a few clicks, you can create the ideal workflow for your business!",
      cardRowReverse: true,
      cardBtnText1: "Watch Video",
      cardBtnLink1:
        "https://www.youtube.com/watch?v=riiUkCRpIio&list=PL5JmkY7cOocwnLRcqWkQCjXpVWT780iq_",
      cardClassName: "mt-20 sm:mt-56",
      bgImgSrc: `${BASE_ASSETS_URL}/features/bg_1.svg`,
      bgUpSideDown: true,
      bgContainerStyles: { top: "0px" },
      bgClassNameContainer:
        "top-[0px!important] sm:top-[-50px!important] lg:top-[0px!important] xxl:top-[100px!important]",
      bgImgStyles: { transform: "scaleX(-1)" },
    },
    {
      featuresContainerStyles: "flex-col mt-20 sm:mt-40",
      preCardJsx: (
        <div className="w-full flex flex-col justify-center items-center mt-16 md:mt-0 lg:mt-10 xl:mt-32 min-[1700px]:mt-52">
          <h3 className="text-xl md:text-3xl xl:text-4xl text-white text-center font-semibold mt-0 sm:mt-4">
            Select the Optimal Approval Approach for Your Requirements
          </h3>
          <p className="text-base md:text-lg mt-3 text-white text-center w-full ">
            Utilize Approve & Sign to collect e-signatures and other approval
            actions from your colleagues.
          </p>
          <Link
            target="_blank"
            href={"https://approval-dashboard.boloforms.com/login"}
            className="w-1/2 md:w-fit text-base sm:text-lg text-center font-medium px-6 py-1 sm:py-2 rounded-lg  bg-white text-[#915bff] hover:opacity-90 transition-colors mt-3 lg:mt-10"
          >
            Try for Free
          </Link>
        </div>
      ),
      cardImgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/3.png",
      cardImgAlt: "Approval process",
      cardStyles: { marginTop: "0px" },
      cardImgStyles: { transform: "scale(0.8)" },
      cardImgFullWidth: true,
      cardDisplayTextSection: false,
      bgImgSrc: `${BASE_ASSETS_URL}/features/bg_2.svg`,
      bgContainerStyles: { top: "-100px" },
      bgImgStyles: { transform: "scaleX(-1)" },
      bgClassNameContainer: styles.bg_container_1,
      bgClassNameImg: styles.bg_img_1,
    },
    {
      featuresContainerStyles: "flex-col mt-20",
      preCardJsx: (
        <div className="w-full flex flex-col justify-center items-center mt-16 sm:mt-32 md:mt-10 lg:mt-16 xl:mt-32 xxl:mt-44 min-[1700px]:mt-60 mb-40">
          <h3 className="text-2xl md:text-3xl xl:text-4xl text-white text-center font-semibold mt-4">
            Advanced Approval Settings
          </h3>
          <p className="text-base md:text-lg mt-3 text-white text-center w-full ">
            Level up your approval flow with advanced settings options.
          </p>
        </div>
      ),
      // cardImgSrc: i4,
      cardImgAlt: "",
      cardImgHidden: true,
      // cardHeadingText1: "Custom Outcomes",
      // cardDescText1:
      //   "Approve or deny form submissions, or create your own custom outcomes — like adding respondents to a wait list, putting them on hold, or whatever else you choose.",
      // cardBtnText2: "Try For Free!",
      cardStyles: { marginTop: "0px" },
      // cardClassName: styles.card_mt_1,
      bgImgSrc: `${BASE_ASSETS_URL}/features/bg_2.svg`,
      bgContainerStyles: { top: "-100px" },
      bgClassNameContainer: styles.bg_container_1,
      bgClassNameImg: styles.bg_img_1,
    },
    // {
    //   featuresContainerStyles: "",
    //   cardImgSrc: i5,
    //   cardTagText1: "BoloForms Dashboard",
    //   cardHeadingText1: "Allow Comments",
    //   cardDescText1:
    //     "Enable users to input a comment when they approve or reject requests, allowing for more detailed feedback and facilitating communication between the requester and approver.",
    //     cardRowReverse: true,
    //   bgImgSrc: `${BASE_ASSETS_URL}/features/bg_3.svg`,
    //   bgContainerStyles: { top: "-50px" },
    //   bgImgStyles: {
    //     width: "45%",
    //     transform: "translateX(125%)",
    //     opacity: "0.15",
    //   },
    // },
    {
      featuresContainerStyles: "mt-0",
      cardImgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/4.png",
      cardImgAlt: "E-Signature",
      cardTagText1: "E-Signature",
      cardHeadingText1: "Request e-Signature",
      cardDescText1:
        "Simplify your document signing process by automatically requesting electronic signatures for your documents, such as contracts, purchase orders, or invoices.",
      cardBtnText2: "Try For Free!",
      cardRowReverse: true,
      cardClassName: "mt-0 sm:mt-40",
      // bgImgSrc: `${BASE_ASSETS_URL}/features/bg_4.svg`,
      bgImgSrc: `${BASE_ASSETS_URL}/features/bg_3.svg`,
      // bgContainerStyles: { top: "-100px", right: "0px" },
      bgContainerStyles: { top: "-50px" },
      bgImgStyles: {
        // width: "40%",
        width: "45%",
        // transform: "translateX(-10%)",
        transform: "translateX(125%)",
        opacity: "0.15",
      },
    },
    {
      featuresContainerStyles: "",
      cardImgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/6.png",
      cardImgAlt: "Request more information",
      cardTagText1: "Requests",
      cardHeadingText1: "Request more information",
      cardDescText1:
        "In the event that a form entry is lacking essential information, approvers can effortlessly request the form filler the required information right inside the BoloForms Dashboard.",
      cardBtnText2: "Try For Free!",
      // cardRowReverse: true,
      bgImgSrc: `${BASE_ASSETS_URL}/features/bg_4.svg`,
      //  bgImgSrc: bg3,
      bgContainerStyles: { top: "-100px", right: "0px" },
      //  bgContainerStyles: { top: "-50px" },
      bgImgStyles: {
        width: "40%",
        //  width: "45%",
        transform: "translateX(-10%)",
        //  transform: "translateX(125%)",
        opacity: "0.15",
      },
    },
    {
      featuresContainerStyles: "mt-28 sm:mt-52",
      cardImgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/5.png",
      cardImgAlt: "Customization & Automation",
      cardTagText1: "Customization & Automation",
      cardHeadingText1: "Send Customized Notification Emails",
      cardDescText1:
        "Send notification emails tailored to the specific stages of your approval process.",
      cardHeadingText2: "Send reminder emails",
      cardDescText2:
        "Send automated reminder emails everyday or manually to approval workflow participants to remind them of their tasks.",
      cardClassName: "mt-0 sm:mt-48",
      cardRowReverse: true,
      bgImgSrc: `${BASE_ASSETS_URL}/features/bg_6.svg`,
      bgContainerStyles: { top: "-100px", right: "0px" },
      // bgImgStyles: {
      //   transform: "scaleX(-1)",
      // },
    },
    // {
    //   featuresContainerStyles: "mt-52",
    //   cardImgSrc: i9,
    //   cardTagText1: "Snooze",
    //   cardHeadingText1: "Snooze tasks",
    //   cardDescText1:
    //     "Approvers can put a pause on responding to requests by snoozing tasks in Jotform Inbox. An automated notification email will be sent once the snooze period is over.",
    //   cardBtnText2: "Try For Free!",
    //   cardRowReverse: true,
    //   cardStyles: { marginTop: "200px" },
    //   cardClassName: styles.card_mt_1,
    //   bgImgSrc: `${BASE_ASSETS_URL}/features/bg_6.svg`,
    //   bgContainerStyles: { top: "-100px", right: "0px" },
    // },
    {
      featuresContainerStyles: "flex-col-reverse md:flex-row",
      cardImgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/7.png",
      cardImgAlt: "Dynamic Email",
      cardTagText1: "Dynamic Email",
      cardHeadingText1: "Dynamic approvals",
      cardDescText1:
        "Let each person filling out your form assign their submission to a specific approver. Users can type the email address field on the form, ensuring that each submission goes to the right approver without requiring any extra work on the backend.",
      cardBtnText2: "Try For Free!",
      cardClassName: `${styles.card_mt_1} pb-10 xs:pb-40 md:pb-0`,
      bgImgSrc: `${BASE_ASSETS_URL}/features/bg_1.svg`,
      bgContainerStyles: { bottom: "-200px" },
      bgImgStyles: {
        transform: "scaleX(-1)",
      },
      bgClassNameContainer:
        "bottom-[-100px!important] lg:bottom-[-200px!important] xl:bottom-[-250px!important] xxl:bottom-[-300px!important]",
      // bgClassNameContainer: styles.bg_container_2,
    },
    {
      featuresContainerStyles: "mt-20 lg:mt-40",
      cardImgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/11.png",
      cardImgAlt: "Export Reports",
      cardTagText1: "Reports",
      cardHeadingText1: "Download Approval Reports",
      cardDescText1:
        "Create custom CSV reports to track and summarize your approval history. It’s an easy way to view and document all of the actions taken throughout the approval process.",
      cardBtnText2: "Try For Free!",
      cardRowReverse: true,
      cardClassName: "mt-20 sm:mt-40",
      bgImgSrc: `${BASE_ASSETS_URL}/features/bg_1.svg`,
      bgUpSideDown: true,
      bgContainerStyles: { top: "0px" },
      bgImgStyles: {
        transform: "scaleX(-1)",
      },
      // bgClassNameContainer: styles.bg_container_3,
    },
    {
      featuresContainerStyles: "flex-col mt-20 sm:mt-40",
      preCardJsx: (
        <div className="w-full flex flex-col justify-center items-center mt-20 md:-mt-12 lg:mt-0 xl:mt-10 xxl:mt-20 min-[1700px]:mt-44 mb-20 sm:mb-60">
          <h3 className="text-2xl md:text-3xl xl:text-4xl text-white text-center font-semibold mt-4">
            Set up advanced conditional logic
          </h3>
          <p className="text-base md:text-lg mt-3 text-white text-center w-full ">
            Make sure your tasks are forwarded to the right people with custom
            approval flow conditions.
          </p>
        </div>
      ),
      cardImgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/10.png",
      cardImgAlt: "Conditional Logic",
      cardTagText1: "Conditional Logic",
      cardHeadingText1: "Use if-else conditions",
      cardDescText1:
        "Conditionally route requests to the right approver with our if-else feature. For example, if an expense request over $500 is approved by a finance specialist, you can forward it to your finance manager automatically.",
      cardHeadingText2: "Add multiple approvers",
      cardDescText2:
        "Multiple people have permissions to approve a request and if any one of them approves the request, it is sent to the next step.",
      cardStyles: { marginTop: "0px" },
      bgImgSrc: `${BASE_ASSETS_URL}/features/bg_2.svg`,
      bgContainerStyles: { top: "-200px" },
      bgImgStyles: {
        transform: "scaleX(1.5)",
      },
      bgClassNameContainer: styles.bg_container_1,
      bgClassNameImg: styles.bg_img_1,
    },
    // {
    //   featuresContainerStyles: "mt-52",
    //   cardImgSrc: i13,
    //   cardTagText1: "Merge Parallel Paths",
    //   cardHeadingText1: "Combine different paths in your approval flow.",
    //   cardHeadingText2: "All",
    //   cardDescText2:
    //     "Complete tasks in all branches before moving to the next step.",
    //   cardHeadingText3: "Any",
    //   cardDescText3:
    //     "Complete tasks in any branch before moving to the next step.",
    //   cardRowReverse: true,
    //   cardStyles: { marginTop: "250px" },
    //   cardClassName: styles.card_mt_1,
    //   bgImgSrc: `${BASE_ASSETS_URL}/features/bg_7.svg`,
    //   bgContainerStyles: { top: "-150px", right: "0px" },
    // },
    // {
    //   featuresContainerStyles: "mt-52",
    //   cardImgSrc: i14,
    //   cardTagText1: "My Approvals",
    //   cardHeadingText1: "My Approvals",
    //   cardDescText1:
    //     "Approvers can view all of their tasks n the BoloForms Approver Dashboard.",
    //   cardBtnText2: "Try For Free!",
    //   cardStyles: { marginTop: "300px" },
    //   cardClassName: styles.card_mt_1,
    //   bgImgSrc: `${BASE_ASSETS_URL}/features/bg_7.svg`,
    //   bgContainerStyles: { top: "-150px", right: "0px" },
    //   bgImgStyles: {
    //     transform: "scaleX(-1)",
    //   },
    // },
    {
      featuresContainerStyles: "mt",
      cardImgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/features/9.png",
      cardImgAlt: "Process Management",
      cardTagText1: "Process Management",
      cardHeadingText1: "Track & Manage Processes",
      cardDescText1:
        "Track your approval flows in multiple ways on any device. Complete tasts via email, BoloForms Dashboard, and WhatsApp.",
      cardRowReverse: true,
      cardClassName: "mt-20 sm:mt-40 mb-5 sm:mb-20 md:mb-0",
      bgImgSrc: `${BASE_ASSETS_URL}/features/bg_1.svg`,
      bgContainerStyles: { bottom: "-190px" },
      // bgImgStyles: {
      //   transform: "scaleX(-1)",
      // },
    },
  ];
  return (
    <div className="w-full">
      <Head>
        <meta charSet="utf-8" />
        <title> Approvals Features Signature | BoloForms</title>
        <meta
          name="description"
          content="Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="BoloSign" />
        <meta name="publisher" content="BoloSign " />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link rel="canonical" href="https://www.bolosign.com/features" />

        <meta property="og:url" content="https://www.bolosign.com/features" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Approvals Features Signature | BoloSign"
        />
        <meta
          property="og:description"
          content="BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta
          property="og:image"
          content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta
          property="twitter:url"
          content="https://www.bolosign.com/features"
        />
        <meta
          name="twitter:title"
          content="Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta
          name="twitter:description"
          content="Boloforms helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
        />
        <meta
          name="twitter:image"
          content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
        />
      </Head>
      {features.map((feature, index) => (
        <div
          key={index}
          className={`w-full relative flex justify-center items-center ${feature.featuresContainerStyles}`}
        >
          {feature.preCardJsx && feature.preCardJsx}
          <Cards {...feature} />
          <Background {...feature} />
        </div>
      ))}
      <div className="w-[calc(100%_+_32px)] xs:w-[calc(100%_+_48px)] lg:w-[calc(100%_+_176px)] xxl:w-[calc(100%_+_256px)] -translate-x-4 xs:-translate-x-6 lg:-translate-x-[88px] xxl:-translate-x-[128px] relative flex justify-center items-center">
        <div className="w-full bg-[#ad84ff] relative flex flex-col justify-center items-center mt-40 sm:mt-36 py-12">
          <h3 className="text-3xl md:text-4xl text-center text-white font-semibold px-6 mt-4">
            Create automated approval flows with BoloForms
          </h3>
          <div className="w-full flex flex-col md:flex-row justify-center items-center gap-5 mt-10 px-4 xs:px-6 md:mt-6">
            <Link
              target="_blank"
              href={"https://approval-dashboard.boloforms.com/login"}
              className="w-full md:w-fit text-lg font-medium text-center px-6 py-2 rounded-lg bg-white text-[#915bff] hover:opacity-90 transition-colors"
            >
              Try for Free
            </Link>
          </div>
          <span className="w-full absolute bg-[#ad84ff] h-40 -bottom-40 -z-10"></span>
        </div>
      </div>
    </div>
  );
};
export default Features;
